import React from 'react'

import OPFullLogo from '../Images/OPFullLogo'
import OPLegendLogo from '../Images/OPLegendLogo'
import {
    MainContainerOverride,
    HeaderContainer,
    HeaderInnerContainer,
    HeaderLeft,
    HeaderCenter,
    HeaderRight,
    LoyaltyStatusText,
    HeaderStatsText,
} from './LegendHeader.styled'

interface LegendHeaderProps {
    readonly generatedDate: Date
}

function formatDateAsMonthAndYear(date: Date) {
    // Format date as "[Month name] [YYYY]"
    const formattedDate = new Date(date).toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric',
    })

    // Insert comma: "[Month name] [YYYY]" -> "[Month name], [YYYY]"
    return formattedDate.replace(/(\w+)\s(\d{4})/, '$1, $2') // NOSONAR
}

export default function LegendHeader({
    generatedDate,
}: Readonly<LegendHeaderProps>) {
    return (
        <HeaderContainer data-testid="LegendHeader">
            <HeaderInnerContainer>
                <MainContainerOverride />
                <HeaderLeft>
                    <OPFullLogo />
                </HeaderLeft>
                <HeaderCenter>
                    <HeaderStatsText data-testid="HeaderStatsText">
                        Dealership Statistics:{' '}
                        <span className="date">
                            {formatDateAsMonthAndYear(generatedDate)}
                        </span>
                    </HeaderStatsText>
                </HeaderCenter>
                <HeaderRight>
                    <LoyaltyStatusText>Loyalty Status:</LoyaltyStatusText>
                    <OPLegendLogo />
                </HeaderRight>
            </HeaderInnerContainer>
        </HeaderContainer>
    )
}
